/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./pricing.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../shared/ng1/ng1-pricing.directive";
import * as i3 from "./pricing.component";
var styles_PricingComponent = [i0.styles];
var RenderType_PricingComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_PricingComponent, data: {} });
export { RenderType_PricingComponent as RenderType_PricingComponent };
export function View_PricingComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-ng1-pricing", [], null, null, null, null, null)), i1.ɵdid(1, 999424, null, 0, i2.Ng1PricingDirective, [i1.ElementRef, i1.Injector], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_PricingComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-pricing", [], null, null, null, View_PricingComponent_0, RenderType_PricingComponent)), i1.ɵdid(1, 114688, null, 0, i3.PricingComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var PricingComponentNgFactory = i1.ɵccf("cc-pricing", i3.PricingComponent, View_PricingComponent_Host_0, {}, {}, []);
export { PricingComponentNgFactory as PricingComponentNgFactory };
